import React, { useState } from 'react'
import ApiURL from '../modules/components/ApiURL'
import getToken from '../modules/components/Token'
import { checkLogin } from '../../../@WUM/templates/default/Auth/service/AuthService'

const Allswimelanes = () => {
    const [swimlane, setSwimlane] = useState([]) // Array instead of object
    React.useEffect(() => {
        let root = ApiURL()
        const fetchData = async () => {
            const result = await fetch(root + `Swimlane/`, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + getToken()
                }
            })
                .then((response) => response.json())
                .then((response) => {
                    checkLogin(response)
                    return response
                })
                .catch((err) => console.error(err))

            setSwimlane(result)
        }

        fetchData()
    }, [])

    return swimlane
}

export default Allswimelanes
